import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../store/useAuthStore'
import useRewardStore from '../../store/rewardStore'
import { useLearningStore } from '../../store/useLearningStore'
import styles from '../../styles/user/SolverHeader.module.scss'

const CHARACTER_MAP = {
  explorer: '/assets/avatar/characters/Explorer.png',
  buddy: '/assets/avatar/characters/Buddy.png',
  thinker: '/assets/avatar/characters/Thinker.png',
}

const SolverHeader = ({ userType = 'student' }) => {
  const navigate = useNavigate()
  const user = useAuthStore((state) => state.user)
  const coins = useRewardStore((state) => state.coins)
  const gems = useRewardStore((state) => state.gems)
  const avatar = useRewardStore((state) => state.avatar)
  const fetchRewardSummary = useRewardStore((state) => state.fetchRewardSummary)

  useEffect(() => {
    if (user?.USER_ID) fetchRewardSummary(user.USER_ID).catch(() => {})
  }, [user?.USER_ID])
  const questions = useLearningStore((state) => state.questions)
  const currentQuestionIndex = useLearningStore((state) => state.currentQuestionIndex)

  const isGeneral = userType !== 'student'
  const isQuizOnlyStep = !isGeneral && user?.STEP && user.STEP % 5 === 0

  const activityTitle = isQuizOnlyStep
    ? 'Wrong Answer Activity'
    : isGeneral
      ? 'Level Test'
      : 'Solving Questions'

  const questionLabel = questions.length > 0
    ? `Question ${currentQuestionIndex + 1} of ${questions.length}`
    : isQuizOnlyStep
      ? 'Review Mistakes'
      : isGeneral
        ? 'Level Test'
        : `Lesson ${user?.LEVEL_ID || ''}`

  const characterKey = (avatar?.character || 'explorer').toLowerCase()
  const characterImg = CHARACTER_MAP[characterKey] || CHARACTER_MAP.explorer

  const userName = user?.NAME || 'Student'

  return (
    <header className={styles.solverHeader}>
      <div
        className={styles.headerCard}
        style={{
          backgroundImage: `url('/assets/${isQuizOnlyStep ? 'wrong-logo-bg' : 'solver-logo-bg'}.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >

        {/* Left: 로고 섹션 — 클릭 시 대시보드 이동 */}
        <div className={styles.logoSection} onClick={() => navigate('/dashboard/individual')} style={{ cursor: 'pointer' }}>
          <div className={styles.logoIconWrap}>
            <img src="/assets/white-logo.svg" alt="" className={styles.logoIconImg} />
          </div>
          <div className={styles.logoTextBlock}>
            <span className={styles.logoName}>Solution M</span>
            <span className={styles.logoSub}>kids math</span>
          </div>
        </div>

        {/* Center: 캐릭터 + 활동 정보 */}
        <div className={styles.headerCenter}>
          <img src="/assets/solver-character.png" alt="character" className={styles.characterImg} />
          <div className={styles.activityInfo}>
            <div
              className={styles.activityTitle}
              style={isQuizOnlyStep ? { color: '#5C2D00', textShadow: '0 1px 3px rgba(255,255,255,0.5)' } : undefined}
            >
              {activityTitle}
            </div>
            <div
              className={styles.activityBadge}
              style={isQuizOnlyStep ? { background: 'rgba(92,45,0,0.75)', borderColor: 'rgba(255,255,255,0.4)' } : undefined}
            >
              {questionLabel}
            </div>
          </div>
        </div>

        {/* Right: 보상 + 유저 */}
        <div className={styles.headerRight}>
          <div className={styles.rewardChip}>
            <img src="/assets/icons/coin.png" alt="coin" className={styles.rewardIcon} />
            <span className={styles.rewardValue}>{coins.toLocaleString()}</span>
          </div>
          <div className={styles.rewardDivider} />
          <div className={styles.rewardChip}>
            <img src="/assets/icons/gem.png" alt="gem" className={styles.rewardIcon} />
            <span className={styles.rewardValue}>{gems}</span>
          </div>
          <div className={styles.rewardDivider} />
          <div className={styles.userChip} onClick={() => navigate('/dashboard/individual')} style={{ cursor: 'pointer' }}>
            <img src={characterImg} alt="avatar" className={styles.userAvatar} />
            <div className={styles.userInfo}>
              <span className={styles.userName}>{userName}</span>
            </div>
          </div>
        </div>

      </div>
    </header>
  )
}

export default SolverHeader
